import { render, staticRenderFns } from "./Esim-Order-Modal.vue?vue&type=template&id=c1226056&"
import script from "./Esim-Order-Modal.vue?vue&type=script&lang=js&"
export * from "./Esim-Order-Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports